/**
 * 获得当前页面链接中的查询参数
 * @param {null} 无需输入参数
 * @return {object} 查询参数组成的key-vaule组合对象
 * */
export function getParams(url = location.href) {
  const params1 = {};

  const url1 = new URL(url);
  const urlParams = new URLSearchParams(url1.search);

  urlParams.forEach((value, key) => {
    params1[key] = decodeURIComponent(value);
  });

  return params1;
}

export function getChannel(key) {
  return getParams()[key || 'channel'] || localStorage.getItem(key || 'channel') || '';
}
